'use client';

import { useEffect } from 'react';
import { logger } from '@/lib/logger';
import { ErrorDisplay } from '@/components/error-display';

export default function AuthError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    logger.error('Auth error:', error);
  }, [error]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <ErrorDisplay
        title="Authentication error"
        message="We ran into a problem. Please try signing in again."
        error={error}
        onRetry={reset}
        onGoHome={() => window.location.href = '/auth/login'}
      />
    </div>
  );
}
